import customHeaders, { getSpace } from '../../../../common/headers';
import { useState, useEffect } from 'react'
import { TitlePage } from '../../../TitlePage/TitlePage'
import { ButtonBasic, NoDataContent } from '@lk-gtcom/ecomlab-components';
import { useResponseHandler } from '../../../../common/auth';
import useGeneralStore from '../../../../store/general';
import { ModalComponent } from '../../ModalComponent/ModalComponent';
import './ModalDeleteFileToken.scss'

const ModalDeleteFileToken = ({
    setIsModal,
    selectedDirectory,
    setSelectedDirectory
}) => {

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();

    const [tokenList, setTokenList] = useState(null)

    // Получение списка токенов
    const fetchGetTokenList = () => {
        let url = 'https://apps2.ecomru.ru:4460/api/v1/access-tokens'

        fetch(url, { headers })
            .then(handleTableResponse)
            .then((json) => setTokenList(json?.tokens))
            .catch(handleRequestError);
    };

    // Удаление токена
    const handleDeleteToken = (tokenId) => {
        let url = `https://apps2.ecomru.ru:4460/api/v1/access-tokens/${tokenId}`

        fetch(url, {
            method: 'DELETE',
            headers
        })
            .then(handleStatusCode)
            .then(() => {
                // Обновляем список токенов после удаления
                fetchGetTokenList();
            })
            .catch(handleRequestError);
    };

    useEffect(() => {
        fetchGetTokenList()
    }, []);

    return (
        <ModalComponent
            title={`Удалить токены для папки ID-${selectedDirectory}`}
            onClose={(e) => {
                setSelectedDirectory(null)
                setIsModal(false);
            }}
            style={{
                maxWidth: '600px',
                height: 'auto'
            }}
            isNoData={!tokenList?.length}
            child={
                <div className="modal-delete-file-token">

                    <div className="modal-delete-file-token__tokens-list">
                        {tokenList && tokenList.length > 0 ?
                            tokenList.map(({ id, permissions, period_months, created_at, expires_at, directory_id }) => (
                                <div key={id} className="modal-delete-file-token__token-item">
                                    <div className="modal-delete-file-token__token-info">
                                        <div className="modal-delete-file-token__token-id">
                                            <strong>ID токена:</strong> {id}
                                        </div>
                                        <div className="modal-delete-file-token__token-permissions">
                                            <strong>Права:</strong> {permissions === 'write' ? 'Соавтор' : 'Читатель'}
                                        </div>
                                        <div className="modal-delete-file-token__token-period">
                                            <strong>Срок (мес.):</strong> {period_months}
                                        </div>
                                        <div className="modal-delete-file-token__token-created">
                                            <strong>Создан:</strong> {new Date(created_at).toLocaleString()}
                                        </div>
                                        <div className="modal-delete-file-token__token-expires">
                                            <strong>Истекает:</strong> {new Date(expires_at).toLocaleString()}
                                        </div>
                                        <div className="modal-delete-file-token__token-directory">
                                            <strong>ID папки:</strong> {directory_id}
                                        </div>
                                    </div>
                                    <ButtonBasic
                                        red
                                        width="100%"
                                        text={`Удалить токен ${id}`}
                                        onClick={() => handleDeleteToken(id)}
                                    />
                                </div>
                            ))
                            :
                            <NoDataContent
                                height='400px'
                                description={'Нет доступных токенов для удаления'}
                                border={false}
                            />
                        }
                    </div>
                </div>
            }
        />
    )
}

export { ModalDeleteFileToken }